import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: clamp(40px, 4vw + 1rem, 50px);
  flex-wrap: wrap;
`
